import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupD} gsapdGroupD1`}>
            <div className="a-msg-in">
                <div className="a-msg-box">
                    <div className="msg-line-a1">{t('Interior Design')}</div>
                    <div className="msg-line-a2">{t('ID_desc')}</div>
                </div>
                <div className="a-img-box">
                    <div className="gsapdGroupe-canvas1" id="gsapdGroupe-canvas1"></div>
                </div>
            </div>
        </div>
    );
}
